const promiseCache = new Map();

export async function graphQlFetchFunction(
  payload: string,
  isContentPreview?: boolean,
  useCache?: boolean
) {
  const cacheKey = JSON.stringify({ payload, isContentPreview });
  if (useCache && promiseCache.has(cacheKey)) {
    return promiseCache.get(cacheKey);
  }

  try {
    const promise = fetch(`${process.env.NEXT_PUBLIC_GRAPHQL_API}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${isContentPreview ? process.env.NEXT_PUBLIC_PREVIEW_GRAPHQL_AUTH : process.env.NEXT_PUBLIC_GRAPHQL_AUTH}`,
      },
      body: JSON.stringify({ query: payload }),
      cache: "no-cache",
    }).then((res) => res.json());
    if (useCache) {
      promiseCache.set(cacheKey, promise);
    }
    return await promise;
  } catch (error) {
    if (useCache) {
      promiseCache.delete(cacheKey);
    }
    console.error("Error fetching data:", error);
    throw error;
  }
}
